<template>
  <div class="intellidata-device-iorecord">
    <ListPageLayout :loading="tableLoading">
    <template #filter>
        <!--左侧上方搜索框-->
            <div class="searchbox">
              <form action="#" method="get" class="form-inline form-float">
                <div class="form-group">
                  <el-select
                    style="width: 140px;"
                    class="space-parking"
                    placeholder="请选择提现规则"
                    clearable
                    filterable
                    v-model="search.ruleId"
                    @clear="search.ruleId = undefined"
                  >
                    <el-option
                      v-for="ops in withdrawRuleOps"
                      :key="ops.value"
                      :value="ops.value"
                      :label="ops.label"
                    ></el-option>
                  </el-select>
                </div>
                <div class="form-group">
                  <el-select
                    style="width: 140px;"
                    class="space-parking"
                    placeholder="请选择提现状态"
                    clearable
                    filterable
                    v-model="search.status"
                    @clear="search.status = undefined"
                  >
                    <el-option
                      v-for="[key, value] in Object.entries(applicationStatus)"
                      :key="key"
                      :value="key"
                      :label="value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="form-group" style="display: flex;align-items: center">
                  <el-input
                    class="space-parking"
                    style="width: 140px;"
                    type="text"
                    placeholder="请输入手机号码"
                    maxlength="11"
                    clearable
                    v-model="search.mobile"
                    @clear="search.mobile = undefined"
                  />
                </div>
                <div class="form-group" style="display: flex;align-items: center">
                  <el-input
                    class="space-parking"
                    style="width: 155px;"
                    type="text"
                    placeholder="请输入提现人名称"
                    maxlength="11"
                    clearable
                    v-model="search.username"
                    @clear="search.username = undefined"
                  />
                </div>
                <div class="form-group others">
                  <span class="search_btn">
                    <button
                      @click="searchList"
                      type="button"
                      class="btn btn-primary"
                      id="search_btn" :disabled="tableLoading">
              <i v-if="tableLoading" class="el-icon-loading"></i>
              {{ tableLoading ? "查询中..." : "查询" }}
            </button>
                  </span>
                  <span class="search_btn">
                    <button
                      @click="handleBatchOperate"
                      type="button"
                      class="btn btn-primary"
                      :disabled="batchIds.length === 0"
                    >
                      批量通过
                    </button>
                  </span>
                  <span class="search_btn">
                    <button
                      @click="handleBatchOperate"
                      type="button"
                      class="btn btn-primary"
                      :disabled="batchIds.length === 0"
                    >
                      批量拒绝
                    </button>
                  </span>
                </div>
              </form>
            </div>
            <!--左侧列表展示进出场记录-->
    </template>

      <el-table
              ref="table"
              border
              :data="tableListData.rows"
              height="100%"
              width="100%"
              :header-cell-style="tableHeaderStyle"
              :cell-style="styleObj"
              @selection-change="checkedList"
            >
              <el-table-column
                type="selection"
                width="55"
                :selectable="(row) => row.status === 1"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="提现规则名称"
                prop="ruleName"
                width="180"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="用户ID"
                prop="userId"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="openid"
                prop="openid"
              ></el-table-column>

              <el-table-column show-overflow-tooltip label="手机号" prop="mobile">
              </el-table-column>

              <el-table-column
                show-overflow-tooltip
                label="用户名"
                prop="userName"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="可提现金额"
                prop="accountAmount"
              >
              </el-table-column>

              <el-table-column
                show-overflow-tooltip
                label="本次提现金额"
                prop="withdrawAmount"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="剩余可提现金额"
                prop="balance"
              >
              </el-table-column>
              <el-table-column show-overflow-tooltip label="状态">
                <template slot-scope="scope">
                  <span>{{ applicationStatus[scope.row.status] }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip label="备注" prop="remark">
                <template slot-scope="scope">
                  <span>{{ utils.getOrDefault(scope.row.remark, "-") }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="申请时间"
                prop="crtTime"
                width="150"
              >
              </el-table-column>
              <el-table-column show-overflow-tooltip label="操作">
                <template slot-scope="scope">
                  <button
                    :style="{
                      cursor: scope.row.status == 1 ? 'pointer' : 'not-allowed',
                      color: scope.row.status == 1 ? '' : '#666',
                    }"
                    :disabled="scope.row.status == 2 || scope.row.status == 3"
                    class="operate-button"
                    type="button"
                    @click="audit(scope.row, 1)"
                  >
                    审核
                  </button>
                </template>
              </el-table-column>
            </el-table>

      <template #pagination>
        <Page v-on:pagination="receivePaginationData"></Page>
      </template>
    </ListPageLayout>
    <el-dialog
          title="提现审核"
          :visible.sync="dialogFormVisible"
          width="28%"
          @closed="handleAuditDialogClose"
        >
          <div v-loading="auditDialogLoading">
            <!-- 内容区域 -->
            <el-form label-position="right" label-width="120px" class="dialog-form">
              <el-form-item label="提现规则名称: ">
                <div class="rule-row">
                  {{ currentRule.ruleName }}
                </div>
              </el-form-item>
              <el-form-item label="提现规则负责人: ">
                <div class="rule-row">
                  {{ convertToUserLabel(currentRule.userId) }}
                </div>
              </el-form-item>
              <el-form-item label="验证方式: ">
                <div class="rule-row">
                  {{ currentRule.validateType === 1 ? "验证码" : "密码" }}
                </div>
              </el-form-item>
              <template v-if="currentRule.validateType === 1">
                <el-form-item label="手机号码: ">
                  <div class="rule-row">
                    {{ currentRule.validateValue }}
                  </div>
                </el-form-item>
                <el-form-item label="验证码: ">
                  <el-col :span="12">
                    <el-input
                      v-model="auditForm.validateValue"
                      placeholder="请输入验证码"
                      :maxlength="5"
                    ></el-input>
                  </el-col>

                  <el-col :span="4" :offset="1">
                    <el-button
                      size="mini"
                      style="margin-top: -3px;"
                      @click="handleCodeSend"
                      :disabled="leftSecond >= 0"
                      >{{
                        leftSecond >= 0 ? `重发(${leftSecond})` : "发送验证码"
                      }}</el-button
                    >
                  </el-col>
                </el-form-item>
              </template>
              <el-form-item v-else label="密码: ">
                <el-col :span="12">
                  <el-input
                    type="password"
                    v-model="auditForm.validateValue"
                    placeholder="请输入验证密码"
                  ></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="备注信息: ">
                <el-input
                  v-model="auditForm.remark"
                  placeholder="请输入备注信息"
                  :maxlength="20"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="dialog-footer">
              <el-button type="primary" @click="onPassBtn" size="mini"
                >通过</el-button
              >
              <el-button @click="onRejectBtn" size="mini">拒绝</el-button>
            </div>
          </div>
        </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  sendWithdrawCode,
  withdrawApplication,
  withdrawApplicationAudit,
  withdrawRuleByApplication,
  groupUserOps,
  withdrawRuleOps,
} from "@/api/url";

import Page from "../../commons/page";
import ListPageLayout from '@/page/commons/ListPageLayout.vue';
import * as utils from "@/utils/utils";

export default {
  data() {
    return {
      tableLoading: false,
      applicationStatus: {
        1: "申请中",
        2: "已通过",
        3: "已拒绝",
      },
      parks: [],
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        status: undefined,
        ruleId: undefined,
        mobile: undefined,
        username: undefined,
      },
      tableListData: {
        rows: [],
      },

      dialogFormVisible: false,
      row: {},
      batchIds: [],
      currentRule: {},
      auditForm: {
        // 规则 id
        ruleId: undefined,
        // 验证值。密码/验证码
        validateValue: undefined,
        remark: undefined,
      },
      leftSecond: -1,
      userOps: [],
      withdrawRuleOps: [],
      auditType: undefined,
      auditDialogLoading: false,
      utils,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      _this.tableLoading = true;
      this.$get(withdrawApplication(), {
        limit: this.search.pageSize,
        page: curPage,
        status: this.search.status,
        ruleId: this.search.ruleId,
        mobile: this.search.mobile,
        username: this.search.username,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页

          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData = data.data;
        })
        .finally(() => (_this.tableLoading = false));
    },
    searchList: function() {
      if (this.tableLoading) return;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
      this.tableList(this.search.pageNumber);
    },

    // getShareParks() {
    //   this.$postRequest(shareParks(), {}).then((res) => {
    //     this.parks = res?.data?.data?.rows ?? [];
    //   });
    // },
    async getWthdrawRule() {
      const data = await this.$get(withdrawRuleByApplication(this.row.id));
      if (data.status === 200) {
        this.currentRule = data.data;
        this.auditForm.ruleId = this.currentRule.id;
      } else {
        this.$message({ type: "error", message: "获取提现规则失败" });
      }
    },
    async audit(row, type) {
      this.dialogFormVisible = true;
      this.auditDialogLoading = true;
      this.row = row;
      this.auditType = type;
      await this.getWthdrawRule();
      await this.getUserOps();
      this.auditDialogLoading = false;
    },
    async handleBatchOperate() {
      if (this.batchIds && this.batchIds.length > 0) {
        if (this.tableListData.rows.length === 0) return;
        const filtered = this.tableListData.rows.filter((f) => {
          return this.batchIds.includes(f.id);
        });
        if (filtered.length > 0) {
          const first = filtered[0];
          const noSameRule = filtered.filter((f) => f.ruleId != first.ruleId);
          if (noSameRule.length > 0)
            return this.$message({
              type: "error",
              message: "不能对不同提现规则的记录进行批量操作",
            });

          await this.audit({ id: this.batchIds[0] }, 2);
        }
      }
    },
    checkValidateValue() {
      if (!this.auditForm.validateValue) {
        this.$message({
          type: "error",
          message:
            this.currentRule.validateType === 1 ? "请输入验证码" : "请输入密码",
        });
        throw Error("validateValue is null");
      }
    },
    onPassBtn() {
      this.checkValidateValue();
      this.auditDialogLoading = true;
      this.$postRequest(withdrawApplicationAudit(), {
        ids: this.auditType === 1 ? [this.row.id] : this.batchIds,
        status: 2,
        validateValue: this.auditForm.validateValue,
        remark: this.auditForm.remark,
      })
        .then((res) => {
          if (res.status != 200) return;
          this.dialogFormVisible = false;
          this.tableList(this.curIndex);
        })
        .finally(() => (this.auditDialogLoading = false));
    },
    onRejectBtn() {
      this.checkValidateValue();
      this.auditDialogLoading = true;
      this.$postRequest(withdrawApplicationAudit(), {
        ids: this.auditType === 1 ? [this.row.id] : this.batchIds,
        status: 3,
        validateValue: this.auditForm.validateValue,
        remark: this.auditForm.remark,
      })
        .then((res) => {
          if (res.status != 200) return;
          this.dialogFormVisible = false;
          this.tableList(this.curIndex);
        })
        .finally(() => (this.auditDialogLoading = false));
    },
    checkedList(val) {
      this.batchIds = val.map((item) => {
        return item.id;
      });
    },
    async handleCodeSend() {
      if (
        this.currentRule.validateType != 1 ||
        this.currentRule.validateValue.length == 0
      ) {
        this.$message({ type: "error", message: "手机号码异常" });
        return;
      }

      // 发送验证码
      this.auditDialogLoading = true;
      const data = await this.$postRequest(sendWithdrawCode(), {
        mobile: this.currentRule.validateValue,
        type: 2,
      });
      if (data.data === true) {
        this.leftSecond = 60;
        const timer = setInterval(() => {
          if (this.leftSecond < 0) {
            clearInterval(timer);
            return;
          }

          this.leftSecond -= 1;
        }, 1000);
        this.$message({ type: "success", message: "短信验证码发送成功" });
      }
      this.auditDialogLoading = false;
    },
    async getUserOps() {
      const data = await this.$get(groupUserOps());
      if (data.status == 200) this.userOps = data.data;
    },
    getWithdrawRuleOps() {
      this.$get(withdrawRuleOps()).then((res) => {
        if (res.status === 200) this.withdrawRuleOps = res.data;
      });
    },
    convertToUserLabel: function(userId) {
      let targetLabel = "-";
      this.userOps.forEach((f) => {
        f.children.forEach((fc) => {
          if (fc.value == userId) {
            targetLabel = `${f.label}/${fc.label}`;
            return;
          }
        });
      });
      return targetLabel;
    },
    handleAuditDialogClose() {
      this.auditForm.ruleId = undefined;
      this.auditForm.validateValue = undefined;
      this.auditForm.remark = undefined;
      this.auditType = undefined;
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    ListPageLayout,
    Page,
  },

  mounted: function() {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
    this.getWithdrawRuleOps();
    // this.getShareParks();
  },
};
</script>

<style scoped>
.boxbgcolor {
  width: 100%;
  display: flex;
}
.table tr td {
  text-align: center;
}

.dialog-form .el-form-item {
  margin: 0;
}
.dialog-form .el-divider {
  margin: 0;
  margin-bottom: 10px;
}
.dialog-form .el-select {
  width: 100%;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
          line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.intellidata-device-iorecord img {
  display: inline-block;
  margin-right: 2px;
}
.rule-row {
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
